import {BaseService} from "./base.service";

class KindFileStationeryService extends BaseService {
    constructor() {
        super('api/kind-file-stationery');
    }
}

export const kindfilestationeryService = new KindFileStationeryService();
